import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceListEntryComponent } from './invoice-list-entry/invoice-list-entry.component';
import { NgClass } from '@angular/common';
import { FirestoreInvoice } from '@jessie/commons';
import { EmptyStateComponent } from '../../../components/empty/empty-state.component';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    imports: [InvoiceListEntryComponent, NgClass, EmptyStateComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoicesComponent {
  @Input() invoices: FirestoreInvoice[] = [];
  @Output() editInvoice = new EventEmitter<FirestoreInvoice>();
}
